<template>
    <b-container class="survey">
        <b-row>
            <b-col v-if="survey && !showError && !showComplete">
                <b-row class="survey-title">
                    <b-col class="text-left">{{survey.title}}</b-col>
                </b-row>
                <b-row class="survey-description text-left">
                    <b-col v-html="survey.description"></b-col>
                </b-row>
                <b-row v-for="(question, index) in questions" class="question" :id="question.id">
                    <b-col>
                        <b-row class="question-title">
                            <b-col class="text-left">{{index+1}}. {{question.title}} <span style="color: red">{{question.required ? '*' : ''}}</span></b-col>
                        </b-row>
                        <b-row class="question-title" v-if="question.type === 'single_line'">
                            <b-col>
                                <b-form-input class="question-free-text-input" v-model="answers[question.id]"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="question-title" v-if="question.type === 'freetext'">
                            <b-col>
                                <b-form-textarea class="question-free-text-input" v-model="answers[question.id]"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="question-title" v-if="question.type === 'rating'">
                            <b-col>
                                <b-row>
                                    <b-col cols="2"></b-col>
                                    <b-col>
                                        <b-row>
                                            <b-col>1</b-col>
                                            <b-col>2</b-col>
                                            <b-col>3</b-col>
                                            <b-col>4</b-col>
                                            <b-col>5</b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="2"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="2" class="text-right">{{question.min_label}}</b-col>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <b-form-radio v-model="answers[question.id]" :name="question.id" :value="1"></b-form-radio>
                                            </b-col>
                                            <b-col>
                                                <b-form-radio v-model="answers[question.id]" :name="question.id" :value="2"></b-form-radio>
                                            </b-col>
                                            <b-col>
                                                <b-form-radio v-model="answers[question.id]" :name="question.id" :value="3"></b-form-radio>
                                            </b-col>
                                            <b-col>
                                                <b-form-radio v-model="answers[question.id]" :name="question.id" :value="4"></b-form-radio>
                                            </b-col>
                                            <b-col>
                                                <b-form-radio v-model="answers[question.id]" :name="question.id" :value="5"></b-form-radio>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="2" class="text-left">{{question.max_label}}</b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button @click="submit">{{$t('submit')}}</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="showError" class="error-msg">
            <b-col>
                {{$t('survey.error_msg')}}
            </b-col>
        </b-row>
        <b-row v-if="showComplete" class="complete-msg">
            <b-col>
                {{$t('survey.complete_msg')}}
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import _ from 'lodash'

    export default {
        name: 'Survey',
        components: {},
        data() {
            return {
                responseId: this.$route.params.responseId,
                survey: null,
                questions: [],
                answers: {},
                showError: false,
                showComplete: false,
            };
        },
        mounted() {
            this.getSurvey();
        },
        computed: {},
        methods: {
            getSurvey() {
                this.$callAPI('hkiarace/event/survey/start/', {response_id: this.responseId}, function (response) {
                    this.survey = response.body.survey;

                    this.questions = _.sortBy(this.survey.questions, (q) => q.order);
                }, function (response) {
                    if (response.status === 401) {
                        this.$router.push({name: 'login', query: {after: this.$route.path}})
                    } else {
                        this.showError = true;
                    }
                })
            },
            submit() {
                let v = this;

                for (let i = 0; i < this.questions.length; i++) {
                    let q = this.questions[i];
                    if (q.required && (!(q.id in v.answers) || v.answers[q.id].toString().length === 0)) {
                        window.scrollTo(0, document.getElementById(q.id).offsetTop);
                        return;
                    }
                }

                this.$callAPI('hkiarace/event/survey/submit/', {response_id: this.responseId, answers: this.answers}, function (response) {
                    this.showComplete = true;
                })
            },
        }
    }
</script>

<style lang="less">
    .survey {
        .survey-title {
            font-weight: bold;
            font-size: 2rem;
        }

        .survey-description {
            font-size: 1.5rem;
        }

        .error-msg, .complete-msg {
            font-size: 2rem;
            font-weight: bold;
        }

        .question {
            margin-bottom: 3rem;
        }
    }
</style>